import { Trash2, X, Check, Ban } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useReports } from '../hooks/useReports';

export default function AdminReports() {
  const { reports, loading, updateReportStatus, deleteReport, deleteReview } = useReports();

  if (loading) {
    return <div>Loading reports...</div>;
  }

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-bold mb-4">Reported Reviews</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Extension</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Review</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {reports.map((report) => (
              <tr key={report.id}>
                <td className="px-6 py-4">
                  <Link to={`/extension/${report.extensionId}`} className="text-indigo-600 hover:text-indigo-900">
                    {report.extensionName}
                  </Link>
                </td>
                <td className="px-6 py-4">{report.reviewContent}</td>
                <td className="px-6 py-4">{report.reason}</td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 rounded-full text-sm ${
                    report.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                    report.status === 'resolved' ? 'bg-green-100 text-green-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {report.status}
                  </span>
                </td>
                <td className="px-6 py-4">
                  {report.createdAt?.toDate().toLocaleDateString()}
                </td>
                <td className="px-6 py-4">
                  <div className="flex space-x-2">
                    {report.status === 'pending' && (
                      <>
                        <button
                          onClick={() => updateReportStatus(report.id, 'resolved')}
                          className="text-green-600 hover:text-green-900"
                          title="Mark as Resolved"
                        >
                          <Check className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() => updateReportStatus(report.id, 'dismissed')}
                          className="text-orange-600 hover:text-orange-900"
                          title="Dismiss Report"
                        >
                          <Ban className="w-5 h-5" />
                        </button>
                      </>
                    )}
                    <button
                      onClick={() => deleteReview(report.reviewId, report.extensionId)}
                      className="text-red-600 hover:text-red-900"
                      title="Delete Review"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => deleteReport(report.id)}
                      className="text-gray-600 hover:text-gray-900"
                      title="Delete Report"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 